module.exports = __webpack_public_path__ + "img/portrait-080.50e77fb7.jpg";